import { Module } from '@nestjs/common';
import { AuditModule } from 'src/audit/audit.module';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { ListaPreciosController } from './lista-precios.controller';
import { ListaPreciosService } from './lista-precios.service';

@Module({
  imports: [PrismaModule, AuditModule],
  controllers: [ListaPreciosController],
  providers: [ListaPreciosService],
  exports: [ListaPreciosService],
})
export class ListaPreciosModule {}
